import {
  HelpCenterMeta,
  HelpCenterNavigationContainer,
  HelpCenterPageWrapper,
  HighlightedArticles,
  SelfServiceFlowBreadcrumbs,
  SelfServiceFlowFooter,
  SelfServiceFlowSection,
  SelfServiceFlowTitle,
} from '@aboutyou/logic-components';
import React from 'react';

export const SectionPage = () => {
  return (
    <HelpCenterPageWrapper>
      <HelpCenterMeta />
      <HelpCenterNavigationContainer>
        <SelfServiceFlowBreadcrumbs />
        <SelfServiceFlowTitle />
        <SelfServiceFlowSection />
      </HelpCenterNavigationContainer>
      <HighlightedArticles />
      <SelfServiceFlowFooter />
    </HelpCenterPageWrapper>
  );
};
